<h6 id="table_sopralluoghiOperaList">Elenco sopralluoghi</h6>
<div style="transform: rotateX(180deg);" class="table-responsive mb-3">
    <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_documentoOperaList">
        <thead class="thead-light">
            <tr>
                <th scope="col">ID</th>
                <th scope="col">Tipologia rilevamento</th>
                <th scope="col">Data rilevamento</th>
                <th scope="col">Rilevatore</th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of items">
                <td>{{ item.idRilevamento }}</td>
                <td>{{ item.idTipologia | anagraficaTipologiaRilevamento: (datalist.tipologiaRilevamento || []) }}</td>
                <td>{{ item.dataRilevamento | date: 'dd/MM/yyyy' }}</td>
                <td>{{ item.rilevatore }}</td>
                <td class="actions">
                    <button aria-label="visualizza dettagli" type="button" class="btn btn-xs btn-link" (click)="viewItem(item)" container="body" ngbTooltip="Visualizza dettaglio">
                        <app-toolkit-bl-icon icon="search" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="modifica" *ngIf="canEdit" type="button" class="btn btn-xs btn-link" container="body" (click)="editItem(item)" ngbTooltip="Modifica">
                        <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                    </button>
                    <button aria-label="elimina" *ngIf="canEdit" type="button" class="btn btn-xs btn-link" container="body" (click)="deleteItem(item.idRilevamento)" ngbTooltip="Elimina">
                        <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="!items.length">
                <td colspan="4"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
            </tr>
        </tbody>
    </table>
</div>
<div *ngIf="canEdit" class="button-actions">
    <button type="button" class="btn btn-outline-primary" (click)="addItem()">
        <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
        Aggiungi
    </button>
</div>
<!-- <ng-template #modalViewDetails let-modalViewDetails>
	<div class="modal-header">
		<h4 class="modal-title">Dettagli rilevamento</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalViewDetails.close()">
            <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
        </button>
	</div>
	<div class="modal-body">
        <div class="row">
            <div class="col-4">
                <p>ID rilevamento: <strong>{{ currentItem.idRilevamento }}</strong></p>
            </div>
            <div class="col-4">
                <p>Fonte: <strong>{{ currentItem.idFonte | anagraficaFonte: (datalist.fonte || []) }}</strong></p>
            </div>
            <div class="col-4">
                <p>Rilevatore: <strong>{{ currentItem.rilevatore }}</strong></p>
            </div>
            <div class="col-4">
                <p>Data rilevamento: <strong>{{ currentItem.dataRilevamento | date: 'dd/MM/yyyy' }}</strong></p>
            </div>
            <div class="col-4">
                <p>Efficacia: <strong>{{ currentItem.efficacia  | anagraficaFascePercentuali: ( datalist.fascePercentuali || []) }}</strong></p>
            </div>
            <div class="col-4">
                <p>Efficienza: <strong>{{ currentItem.efficienza  | anagraficaFascePercentuali: ( datalist.fascePercentuali || []) }}</strong></p>
            </div>
            <div class="col-4">
                <p>Tipo evento: <strong>{{ currentItem.idTipoEvento | anagraficaEvento: (datalist.evento || []) }}</strong></p>
            </div>
            <div class="col-4">
                <p>Data evento: <strong>{{ currentItem.dataEvento | date: 'dd/MM/yyyy' }}</strong></p>
            </div>
            <div class="col-12">
                <p>Descrizione evento:<br/><strong>{{ currentItem.descrizioneEvento }}</strong></p>
            </div>
            <div class="col-12">
                <p>Descrizione danno:<br/><strong>{{ currentItem.descrizioneDanno }}</strong></p>
            </div>
            <div class="col-4">
                <p>Entità danno: <strong>{{ currentItem.entitaDanno.descrizione }}</strong></p>
            </div>
            <div class="col-4">
                <p>Richiesta finanziamento: <strong>{{ currentItem.richiestaFinanziamento | currency:'EUR':'symbol':'1.2-2':'it' }}</strong></p>
            </div>
            <div class="col-12">
                <p>Proposta intervento:<br/><strong>{{ currentItem.propostaIntervento }}</strong></p>
            </div>
            <div class="col-12">
                <p>Note:<br/><strong>{{ currentItem.note }}</strong></p>
            </div>
        </div>
        <div class="row">
            <h6>Monitoraggio</h6>
        </div>
        <div class="row">
            <h6>Manutenzione</h6>
        </div>
    </div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-primary" (click)="modalViewDetails.close()">Chiudi</button>
	</div>
</ng-template> -->